<template>
  <!--加保组件-->
  <div class="money-box">
    <!-- <div class="money-text" v-if="detail.totalInsured">当前保额<span>{{detail.totalInsured}}</span>元，再投一笔为孩子获取更多收益</div> -->
    <div class="money-text">立即加保，获取更多收益~</div>
    <div class="btn-list">
      <template v-if="detail.cashValueJump">
        <div class="btn" v-if="detail.cashValueJump.type == 2 && isWeixin">
          <wxOpen :username="detail.cashValueJump.config.split(':')[0]" :path="detail.cashValueJump.config.split(':')[1]" :content="wxtemplate"></wxOpen
          >加保记录
        </div>
        <div
          class="btn"
          v-else-if="detail.cashValueJump.type != 2 && detail.cashValueJump.config"
          @click="jumpPage('/m/order/addPolicyList?policyNo=' + detail.policyNo)"
        >
          加保记录
        </div>
      </template>

      <template v-if="detail.showTransfer && detail.transferJump">
        <div class="btn" v-if="detail.transferJump.type == 2 && isWeixin">
          <wxOpen :username="detail.transferJump.config.split(':')[0]" :path="detail.transferJump.config.split(':')[1]" :content="wxtemplate"></wxOpen>转出
        </div>
        <div class="btn" v-else-if="detail.transferJump.type != 2 && detail.transferJump.config" @click="jumpPage(detail.transferJump.config)">转出</div>
      </template>

      <!-- 所有加保产品都不显示 -->
      <!-- <div class="btn" v-if="detail.isReceive" @click="$notice.alert(detail.receiveJump.config)" >部分领取</div> -->

      <template v-if="detail.addPolicyJump">
        <div class="btn blue" v-if="detail.addPolicyJump.type == 2 && isWeixin">
          <wxOpen :username="detail.addPolicyJump.config.split(':')[0]" :path="detail.addPolicyJump.config.split(':')[1]" :content="wxtemplate"></wxOpen>再买点
        </div>
        <div class="btn blue" v-else-if="detail.addPolicyJump.type != 2 && detail.addPolicyJump.config" @click="jump(detail.addPolicyJump)">
          再买点
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import wxOpen from '@/components/wxOpen';
export default {
  mixins: [common],
  props: ['detail'],
  components: { wxOpen },
  data() {
    return {
      wxtemplate: "<button style='width:100%;height:100%;opacity:0;'>1</button>",
      isWeixin: false
    };
  },
  methods: {
    jump(addPolicyJump) {
      // 1:跳转 2:微信小程序 3:弹窗
      if (addPolicyJump.type == 3) {
        this.$notice.custom({
          content:addPolicyJump.config,
          className: 'custom-big-modal'
        });
      } else {
        location.href = addPolicyJump.config;
      }
    }
  },
  mounted() {
    this.isWeixin = this.$tools.isWeiXin();
  }
};
</script>
<style lang="scss" scoped>
.money-box {
  padding: 0 30px 30px;
  background-color: #fff;
  margin-top: 20px;
  .money-text {
    height: 90px;
    font-size: 28px;
    display: flex;
    align-items: center;
    span {
      color: #377aff;
    }
  }
  .btn-list {
    text-align: right;
    margin-top: 20px;
    .btn {
      width: 160px;
      text-align: center;
      line-height: 60px;
      border: 1px solid #c4c7cd;
      font-size: 26px;
      color: #333;
      display: inline-block;
      border-radius: 30px;
      margin-left: 20px;
      position: relative;
      &:first-child {
        margin-left: 0;
      }
      &.blue {
        border-color: #236dff;
        color: #377aff;
      }
    }
  }
}
</style>
